import React, { useEffect, useState } from 'react';
import { Button, Space, Table, Input, Form, Modal, Select } from 'antd';
import Swal from 'sweetalert2';
import { customBaseUrl, httpGet, httpPost, httpPut, httpDelete } from '../../store/http';
import { hideLoader, showLoader } from '../../utils/loader';
// import { states, lgas } from 'naija-state-local-government';
import NaijaStates from 'naija-state-local-government';

const { Option } = Select;

const DeliveryFees = () => {
  const [deliveryFees, setDeliveryFees] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm(); // Form for creating
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingFee, setEditingFee] = useState(null);
  const [editForm] = Form.useForm(); // Form for editing
  const [selectedCreateState, setSelectedCreateState] = useState(null);
  const [selectedEditState, setSelectedEditState] = useState(null);
  const [lgas, setLga]= useState([])
 const states = NaijaStates.states();
  const fetchDeliveryFees = async () => {
    setLoading(true);
    showLoader();
    try {
      const res = await httpGet(`${customBaseUrl.cardUrl}/cms/card-request/card/request/delivery-fees`);
      if (res.status) {
        setDeliveryFees(res.data);
      } else {
        Swal.fire('Error', res.message || 'Failed to fetch delivery fees', 'error');
      }
    } catch (error) {
      Swal.fire('Error', 'An error occurred while fetching delivery fees', 'error');
    } finally {
      setLoading(false);
      hideLoader();
    }
  };

  const createDeliveryFee = async (values) => {
    showLoader();
    try {
      const res = await httpPost(`${customBaseUrl.cardUrl}/cms/card-request/card/request/delivery-fee`, values);
      if (res.status) {
        Swal.fire('Success', res.message || 'Delivery fee created successfully', 'success');
        form.resetFields();
        setSelectedCreateState(null); // Reset selected state
        fetchDeliveryFees(); // Refresh the list
      } else {
        Swal.fire('Error', res.message || 'Failed to create delivery fee', 'error');
      } 
    } catch (error) {
      Swal.fire('Error', 'An error occurred while creating delivery fee', 'error');
    } finally {
      hideLoader();
    }
  };

  const handleEdit = (record) => {
    setEditingFee(record);
    editForm.setFieldsValue(record);
    setSelectedEditState(record.state); // Set selected state for edit form
    setShowEditModal(true);
  };

  const handleDelete = async (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        showLoader();
        try {
          const res = await httpDelete(`${customBaseUrl.cardUrl}/cms/card-request/card/request/delivery-fee/${id}`);
          if (res.status === true) {
            Swal.fire('Deleted!', res.message || 'Delivery fee has been deleted.', 'success');
            fetchDeliveryFees();
          } else {
            Swal.fire('Error', res.message || 'Failed to delete delivery fee', 'error');
          }
        } catch (error) {
          Swal.fire('Error', 'An error occurred while deleting delivery fee', 'error');
        } finally {
          hideLoader();
        }
      }
    });
  };

  const updateDeliveryFee = async (values) => {
    showLoader();
    try {
      const res = await httpPut(`${customBaseUrl.cardUrl}/cms/card-request/card/request/delivery-fee/${editingFee.id}`, values);
      if (res.status === true) {
        Swal.fire('Success', res.message || 'Delivery fee updated successfully', 'success');
        setShowEditModal(false);
        setEditingFee(null);
        fetchDeliveryFees();
      } else {
        Swal.fire('Error', res.message || 'Failed to update delivery fee', 'error');
      }
    } catch (error) {
      Swal.fire('Error', 'An error occurred while updating delivery fee', 'error');
    } finally {
      hideLoader();
    }
  };

  useEffect(() => {
    fetchDeliveryFees();
  }, []);

  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id' },
    { title: 'City', dataIndex: 'city', key: 'city' },
    { title: 'State', dataIndex: 'state', key: 'state' },
    { title: 'Fee', dataIndex: 'fee', key: 'fee' },
    { title: 'Date Created', dataIndex: 'createdAt', key: 'dateCreated' },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <Button type="link" onClick={() => handleEdit(record)}>Edit</Button>
          <Button type="link" danger onClick={() => handleDelete(record.id)}>Delete</Button>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <h2>Delivery Fees Management</h2>

      <Form form={form} layout="inline" onFinish={createDeliveryFee} style={{ marginBottom: 20 }}>
        <Form.Item
          name="state"
          rules={[{ required: true, message: 'Please select state!' }]}
        >
          <Select
            placeholder="Select State"
            style={{ width: 150 }}
            onChange={(value) => {
              setSelectedCreateState(value);
              setLga(NaijaStates.lgas(value)?.lgas)
              form.setFieldsValue({ city: undefined }); // Clear city when state changes
            }}
          >
            {states.map((s) => (
              <Option key={s} value={s}>{s}</Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="city"
          rules={[{ required: true, message: 'Please select city!' }]}
        >
          <Select
            placeholder="Select City"
            style={{ width: 150 }}
            disabled={!selectedCreateState}
          >
            {selectedCreateState  && lgas.length > 0 &&
             lgas?.map((city) => (
                  <Option key={city} value={city}>{city}</Option>
                ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="fee"
          rules={[{ required: true, message: 'Please input fee!' }]}
        >
          <Input type="number" placeholder="Fee" />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Create Fee
          </Button>
        </Form.Item>
      </Form>

      <Table
        columns={columns}
        dataSource={deliveryFees}
        loading={loading}
        rowKey="id"
        pagination={{ pageSize: 10 }}
      />

      {/* Edit Delivery Fee Modal */}
      <Modal
        title="Edit Delivery Fee"
        visible={showEditModal}
        onCancel={() => setShowEditModal(false)}
        footer={null}
      >
        <Form form={editForm} layout="vertical" onFinish={updateDeliveryFee}>
          <Form.Item
            name="state"
            label="State"
            rules={[{ required: true, message: 'Please select state!' }]}
          >
            <Select
              placeholder="Select State"
              onChange={(value) => {
                setSelectedEditState(value);
                setLga(NaijaStates.lgas(value)?.lgas)
                editForm.setFieldsValue({ city: undefined }); // Clear city when state changes
              }}
            >
              {states.map((s) => (
                <Option key={s} value={s}>{s}</Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="city"
            label="City"
            rules={[{ required: true, message: 'Please select city!' }]}
          >
            <Select
              placeholder="Select City"
              disabled={!selectedEditState}
            >
              {selectedEditState  && lgas.length > 0 &&
               lgas?.map((city) => (
                      <Option key={city} value={city}>{city}</Option>
                    ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="fee"
            label="Fee"
            rules={[{ required: true, message: 'Please input fee!' }]}
          >
            <Input type="number" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Update Fee
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default DeliveryFees;